import { render, staticRenderFns } from "./serveState.vue?vue&type=template&id=5f48c320&scoped=true"
import script from "./serveState.vue?vue&type=script&lang=js"
export * from "./serveState.vue?vue&type=script&lang=js"
import style0 from "./serveState.vue?vue&type=style&index=0&id=5f48c320&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f48c320",
  null
  
)

export default component.exports